import React from "react";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";
import PaymentForm from "../../components/PaymentForm";

// Billing > Add payment method: Stripe's form in a compact card
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client_secret: "",
    };
  }

  async componentDidMount() {
    let intent = await axios.get("/user/stripe/intent");
    this.setState({ client_secret: intent.data.client_secret });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="ac-narrowpage">
        <Link to="/account/billing" className="ac-link ac-back">
          <ChevronLeftIcon />
          {t("Billing")}
        </Link>
        <section className="ac-card" aria-labelledby="ac-add-payment-h">
          <div className="ac-head">
            <h2 id="ac-add-payment-h" className="ac-title">
              {t("Add payment method")}
            </h2>
          </div>
          <PaymentForm secret={this.state.client_secret} />
        </section>
      </div>
    );
  }
}

export default withTranslation()(Index);
